import React from "react";
import { alertContext } from "../providers/AlertProvider";

function useAlert() {
  const alert = React.useContext(alertContext);

  return alert;
}
export default useAlert;
